import { UPLOAD_MANUAL, GET_MANUALS } from "./types";

const initialState = {
  manuals: [],
  loading: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MANUALS:
      return {
        ...state,
        manuals: action.payload,
      };
    case UPLOAD_MANUAL:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};
